const getActiveClientReservationIdsForSupportCases = (
  clientReservations = [],
  now = Date.now()
) => {
  const activeIds = (clientReservations || [])
    .filter((reservation) => {
      const startDate = Number(reservation?.startDate);
      const endDate = Number(reservation?.endDate);

      if (!Number.isFinite(startDate) || !Number.isFinite(endDate)) return false;

      return startDate <= now && endDate >= now;
    })
    .map((reservation) => reservation?.uid)
    .filter(Boolean);

  return new Set(activeIds);
};

const isSupportActive = (supportCase, activeClientReservationIds) =>
  activeClientReservationIds.has(supportCase?.clientReservationId) &&
  supportCase?.status !== "solved";

const getSupportCasePropertiesByStatus = (status) => {
  switch (status) {
    case "pending":
      return { color: "#f39c12", translationKey: "pending" };
    case "in progress":
      return { color: "#3498db", translationKey: "supportInProgress" };
    case "solved":
      return { color: "#2ecc71", translationKey: "supportCompleted" };
    default:
      return { color: "#7f8c8d", translationKey: "unknown" };
  }
};

const supportCaseUtils = {
  getActiveClientReservationIdsForSupportCases,
  isSupportActive,
  getSupportCasePropertiesByStatus,
};

export default supportCaseUtils;
